module.exports = __webpack_public_path__ + "static/people_img3@2x-e05dd635b502c45cd9112f4aa2fa4fa5.png";